/**
 * "A new version of Bundle is ready — Reload to update / Later" (web, while the tab is busy; an idle tab reloads by
 * itself) and "Bundle 0.2.22 is ready — Restart to update / Later" (desktop, once per downloaded version; it still
 * installs on its own when I'm away or quit). Later hides it; the Help menu, the app menu, the tray and About keep
 * offering the update.
 */
import { Toast, useT } from "@bundle/ui";
import { useState, useSyncExternalStore } from "react";
import { updates } from "../platform/updates.ts";

export function UpdateToast() {
  const t = useT();
  const pending = useSyncExternalStore(updates.subscribe, updates.getSnapshot, updates.getSnapshot);
  const [busy, setBusy] = useState(false);
  const desktop = pending?.kind === "desktop";
  return (
    <Toast
      open={pending !== undefined}
      onClose={() => updates.dismiss()}
      icon={{ name: "download" }}
      message={pending?.kind === "desktop" ? t("update.readyVersion", { version: pending.version }) : t("update.webReadyTitle")}
      description={desktop ? t("update.readyNote") : t("update.webReadyNote")}
      action={{
        label: desktop ? t("update.restartToUpdate") : t("update.reloadToUpdate"),
        testID: "update-apply",
        onPress: () => {
          if (busy) return;
          setBusy(true);
          updates.apply().catch(() => setBusy(false));
        },
      }}
      secondaryAction={{ label: t("update.later"), testID: "update-later", onPress: () => updates.dismiss() }}
      closeLabel={t("common.dismiss")}
      testID="update-toast"
    />
  );
}
